import React, { Component } from 'react';
import { Button, Select, message } from 'antd';
import { RestoreWrapper } from './style';
import EXAMPLES from './seedList.json';

const WORDS = [
	['word1', 'word2', 'word3', 'word4', 'word5', 'word6'],
	['word7', 'word8', 'word9', 'word10', 'word11', 'word12']
];

class SeachableInput extends Component {
	state = {
		data: [],
		value: '',
		search: ''
	};

	componentWillReceiveProps(next) {
		if (next.value !== '') {
			this.setState({ value: next.value });
		}
	}

	onChange = (search) => {
		this.setState({ search }, this.checkList);
	};

	checkList = () => {
		const { search } = this.state;
		if (search.length >= 3) {
			const data = EXAMPLES.seeds.filter(
				(item) => item.indexOf(search) >= 0
			);
			this.setState({ data });
		}
	};

	render() {
		const options = this.state.data.map((item) => (
			<Select.Option key={item} value={item}>
				{item}
			</Select.Option>
		));
		const { data, onChange } = this.props;
		return (
			<div className="seed-word">
				<p>{data}</p>
				<Select
					style={{ width: '100%' }}
					showSearch
					showArrow={false}
					defaultActiveFirstOption={false}
					filterOption={false}
					name="value"
					value={this.state.value}
					onSearch={this.onChange}
					onChange={onChange}
					notFoundContent={null}
				>
					{options}
				</Select>
			</div>
		);
	}
}

class RestoreWallet extends Component {
	componentWillMount() {
		const state = {};
		WORDS[0].forEach((item) => {
			state[item] = '';
		});
		WORDS[1].forEach((item) => {
			state[item] = '';
		});
		this.setState(state);
	}
	onSubmit = (e) => {
		e.preventDefault();
		const { onSubmit } = this.props;
		const words = [];
		let isOk = true;
		const keys = Object.keys(this.state);

		keys
			.sort((a, b) => {
				return a - b;
			})
			.forEach((item) => {
				const word = this.state[item];
				if (word === undefined || word === '') {
					isOk = false;
				} else {
					words.push(this.state[item]);
				}
			});
		if (this.findDuplicates(words).length > 0) {
			message.warn('They are duplticated');
			return;
		}
		if (isOk) {
			onSubmit(words);
		} else {
			message.warn('you drop the some word');
		}
	};

	findDuplicates = (arr) =>
		arr.filter((item, index) => arr.indexOf(item) !== index);

	renderBody = () => {
		const List1 = WORDS[0].map((item) => (
			<SeachableInput
				onChange={(value) => {
					this.setState({ [item]: value });
				}}
				data={item}
				value={this.state[item]}
				key={item}
			/>
		));
		const List2 = WORDS[1].map((item) => (
			<SeachableInput
				onChange={(value) => {
					this.setState({ [item]: value });
				}}
				data={item}
				value={this.state[item]}
				key={item}
			/>
		));
		return (
			<div className="flex-wrap">
				<div>{List1}</div>
				<div>{List2}</div>
			</div>
		);
	};
	render() {
		let disabled = false;
		WORDS[0].forEach((item) => {
			if (this.state[item] === '') {
				disabled = true;
			}
		});
		WORDS[1].forEach((item) => {
			if (this.state[item] === '') {
				disabled = true;
			}
		});
		return (
			<RestoreWrapper className="holla-wallet-confirm">
				<div className="holla-wallet-confirm-desc">
					Your phrase is also known as a mnemonic phrase that should of
					been written down during your wallet creation proccess.
					<br /> Input your 12 word phrase in the precise order below.
				</div>

				{this.renderBody()}

				<Button
					block
					type="primary"
					disabled={disabled}
					onClick={this.onSubmit}
				>
					Create Wallet
				</Button>
			</RestoreWrapper>
		);
	}
}

export default RestoreWallet;
